import { render, staticRenderFns } from "./MediaCarousel.vue?vue&type=template&id=f3f10078&scoped=true"
import script from "./MediaCarousel.vue?vue&type=script&lang=ts"
export * from "./MediaCarousel.vue?vue&type=script&lang=ts"
import style0 from "./MediaCarousel.vue?vue&type=style&index=0&id=f3f10078&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f10078",
  null
  
)

export default component.exports